import { useState } from 'react'
import { Button, notification } from 'antd'
import { useIntl } from 'react-intl'
import { CheckCircleOutlined, ClockCircleOutlined, DownloadOutlined, SendOutlined } from '@ant-design/icons'
import { OrderService } from '../../../../../../services/OrderService'
import { TableOrderItem } from '../OrderErpTable.type'

type Props = {
  orderItem: TableOrderItem;
}

export function CoaCertCell({ orderItem }: Props) {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [requested, setRequested] = useState(false)
  const { coaStatus } = orderItem
  const itemId = Number(orderItem.id)

  if (coaStatus === 'not_required') {
    return (
      <Button
        size='small'
        disabled
        // icon={<CheckCircleOutlined style={{ fontSize: 10, marginRight: -2 }} />}
      >
        {intl.messages['orderTable.columns.coaCert.notRequired']}
      </Button>
    )
  }

  if (!coaStatus || coaStatus === 'waiting') {
    return (
      <Button
        size='small'
        disabled
        icon={<ClockCircleOutlined style={{ fontSize: 10, marginRight: -2 }} />}
      >
        {intl.messages['orderTable.columns.coaCert.waiting']}
      </Button>
    )
  }

  if (coaStatus === 'ready') {
    const handleDownload = async () => {
      setLoading(true)
      try {
        const response = await OrderService.getCoaDownloadUrl(itemId)
        if (response?.url) {
          const link = document.createElement('a')
          link.href = response.url
          link.download = ''
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
      catch (e) {
        console.error('CoA download failed:', e)
        notification.error({
          message: intl.messages['orderTable.columns.coaCert.error'] as string,
        })
      }
      finally {
        setLoading(false)
      }
    }

    return (
      <Button
        size='small'
        type='primary'
        icon={<DownloadOutlined />}
        loading={loading}
        onClick={handleDownload}
      >
        {intl.messages['orderTable.columns.coaCert.download']}
      </Button>
    )
  }

  const handleRequest = async () => {
    setLoading(true)
    try {
      await OrderService.requestCoa(itemId)
      setRequested(true)
      notification.success({
        message: intl.messages['orderTable.columns.coaCert.requestSent'] as string,
      })
    }
    catch (e) {
      console.error('CoA request failed:', e)
      notification.error({
        message: intl.messages['orderTable.columns.coaCert.error'] as string,
      })
    }
    finally {
      setLoading(false)
    }
  }

  return (
    <Button
      size='small'
      style={{ borderColor: '#fa8c16', color: requested ? '#999' : '#fa8c16' }}
      icon={<SendOutlined />}
      loading={loading}
      disabled={requested}
      onClick={handleRequest}
    >
      {requested
        ? intl.messages['orderTable.columns.coaCert.requested']
        : intl.messages['orderTable.columns.coaCert.request']
      }
    </Button>
  )
}
